import { memo } from 'react'
import InfoIconOutlined from '@mui/icons-material/InfoOutlined'
import { Box, Typography } from '@mui/material'

interface Props {
  children: string
  isOpen?: boolean
}

const Tooltip = ({ children, isOpen }: Props) => (
  <>
    <Box
      display="flex"
      gap={1}
      mt={isOpen ? 2 : 0}
      sx={{
        opacity: isOpen ? 1 : 0,
        maxHeight: isOpen ? '1000px' : 0,
        transition: 'all 0.2s ease-in-out'
      }}
    >
      <InfoIconOutlined sx={{ color: '#165297' }} fontSize="small" />
      <Typography variant="body1" fontSize={12} lineHeight={1.6}>
        {children}
      </Typography>
    </Box>
  </>
)

export default memo(Tooltip)
